import * as React from "react"

import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"

import getFreesound from "../../../../../../api/freesounds/get"
import { useAppDispatch, useAppSelector } from "../../../../../../redux"
import { addSnackbar } from "../../../../../../redux/snackbars"
import { FreesoundClip } from "../../../../../../types/Freesound"

export default function FreesoundDetails({
  freesoundId,
}: {
  freesoundId: string
}) {
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  const descriptionClassName =
    (darkModeEnabled ? "dark-mode-links" : "") + " sound-description"

  const dispatch = useAppDispatch()
  const [freesound, setFreesound] = React.useState<FreesoundClip | null>(null)
  const [loading, setLoading] = React.useState(false)

  const getFreesoundDetails = React.useCallback(() => {
    getFreesound(freesoundId)
      .then((freesound) => {
        setFreesound(freesound)
        setLoading(false)
      })
      .catch((err) => {
        console.error(err)
        setLoading(false)
        const text =
          (err.response && err.response.data && err.response.data.error) ||
          err.message

        dispatch(
          addSnackbar({
            id: "getfreesounderror",
            text,
          })
        )
      })
  }, [dispatch, freesoundId])

  React.useEffect(() => {
    setLoading(true)
    getFreesoundDetails()
  }, [freesoundId, getFreesoundDetails])

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
        <CircularProgress />
      </Box>
    )

  if (!freesound)
    return (
      <Typography
        variant="body1"
        component="div"
        color="text.secondary"
        style={{ wordBreak: "break-all" }}
      >
        Failed to load details, try linking your account again from the settings
        page.
      </Typography>
    )

  return (
    <>
      <Typography
        variant="body1"
        component="div"
        color="text.secondary"
        style={{ wordBreak: "break-all" }}
      >
        <b>License:</b>{" "}
        <Link target="_blank" href={freesound.license}>
          {freesound.license}
        </Link>
      </Typography>
      <Typography
        variant="body1"
        component="div"
        color="text.secondary"
        style={{ wordBreak: "break-all" }}
      >
        <b>Webpage:</b>{" "}
        <Link target="_blank" href={freesound.url}>
          {freesound.url}
        </Link>
      </Typography>
      <Typography
        sx={{ mt: 2 }}
        className={descriptionClassName}
        color="text.secondary"
        component="div"
        variant="body1"
        dangerouslySetInnerHTML={{ __html: freesound.description }}
      />
    </>
  )
}
